import { render } from "./ShareBtns.vue?vue&type=template&id=ad1b4d64&scoped=true"
import script from "./ShareBtns.vue?vue&type=script&lang=js"
export * from "./ShareBtns.vue?vue&type=script&lang=js"

import "./ShareBtns.vue?vue&type=style&index=0&id=ad1b4d64&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad1b4d64"]])

export default __exports__